import { render, staticRenderFns } from "./stockproducto.vue?vue&type=template&id=5aae21b4&"
import script from "./stockproducto.vue?vue&type=script&lang=js&"
export * from "./stockproducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports